import React, { FC, useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";

import Prism from "prismjs";

// Import additional languages here in the future
import "prismjs/components/prism-python";

import "prismjs/plugins/line-numbers/prism-line-numbers.css";
import "prismjs/plugins/line-numbers/prism-line-numbers";

import { IconButton } from "gatsby-theme-material-ui";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";
import {
  getLanguageLabel,
  uiContainerTransitionMs,
  uiOpacityHover,
} from "@src/utils";

// Lets extend this when we get more language, today we only show python
export type PrismCodeLanguages = "python";

interface Props {
  language?: PrismCodeLanguages;
  code?: string;
}

const CodeViewer: FC<Props> = ({ language = "python", code = "" }) => {
  useEffect(() => {
    Prism.highlightAll();
  }, [code]);

  return (
    <Stack
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
      }}
      spacing={0}
    >
      <Stack
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
          backgroundColor: "#000000",
          paddingX: "10px",
          height: "32px",
        }}
      >
        <Typography
          sx={{
            color: Colors.SecondaryMain,
            fontFamily: "'Source Code Pro', monospace",
            fontSize: "12px",
          }}
        >
          {getLanguageLabel(language)}
        </Typography>

        <IconButton
          aria-label="copy"
          onClick={() => {
            navigator.clipboard.writeText(code.trim());
          }}
        >
          <CopyAllIcon
            sx={{
              color: Colors.PrimaryContrast,
              width: "16px",
              height: "16px",
              opacity: 1,
              transition: `opacity ${uiContainerTransitionMs}ms ease-in-out`,
              "&:hover": {
                opacity: uiOpacityHover,
              },
            }}
          />
        </IconButton>
      </Stack>

      <Box
        className="theme-pangea Code"
        sx={{
          width: "100%",
          padding: "0px",
          background: Colors.CodeEditorBackground,
          position: "relative",
        }}
      >
        <pre
          className="line-numbers"
          style={{
            position: "relative",
            width: "100%",
            overflowX: "scroll",
            maxHeight: "310px",
            height: "auto",
          }}
        >
          <code className={`language-${language}`}>{code.trim()}</code>
        </pre>
      </Box>
    </Stack>
  );
};

export default CodeViewer;
